import React from 'react';
import { IconProps } from '../types';
const MinecraftFlintAndSteel: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="1" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(158, 158, 158, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(113, 113, 113, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(185, 185, 185, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(158, 158, 158, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(158, 158, 158, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(113, 113, 113, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(113, 113, 113, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(158, 158, 158, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(71, 71, 71, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(158, 158, 158, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="12" y="8" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(113, 113, 113, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(158, 158, 158, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(51, 51, 51, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(50, 50, 50, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(51, 51, 51, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(127, 127, 127, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(51, 51, 51, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(168, 168, 168, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(127, 127, 127, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(51, 51, 51, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(51, 51, 51, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(86, 86, 86, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(40, 40, 40, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(22, 22, 22, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="13" y="14" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
<rect x="10" y="15" width="1" height="1" fill="rgba(7, 7, 7, 255)" />
</svg>);
export default MinecraftFlintAndSteel;